/* eslint-disable */
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import CircularProgress from '@mui/material/CircularProgress'

function ProtectedRoute({ children }) {
    const { authState } = useOktaAuth()

    if (!authState || authState.isPending) {
      return <CircularProgress />
    }

    if (!authState.isAuthenticated) {
      return <Navigate to="/" />
    }
  return children;
}

export default ProtectedRoute
